<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Administration</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Global Settings
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span>Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Settings <span><i class="ic-settings-horizontal"></i></span>
                  </h2>
                  <p>
                    Set all necessary parameters and configurations to support
                    your business.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Key"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>Key</th>
                  <th>Value</th>
                  <th class="text-center">Confidential</th>
                  <th class="text-left">Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td style="text-transform: none">{{ item.key }}</td>
                  <td style="text-transform: none">
                    {{ !item.isConfidential ? item.value : "******" }}
                  </td>
                  <td class="text-center">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isConfidential"
                        :disabled="!isAllowToUpdate"
                        @change="changeStatus(item)"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isConfidential ? "Yes" : "No" }}
                      </span>
                    </label>
                  </td>
                  <td class="text-left">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        :disabled="!isAllowToUpdate"
                        @change="changeStatus(item)"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="!isAllowToUpdate"
                        class="btn btn-default"
                        type="button"
                        @click="viewItem(item)"
                      >
                        <span>View</span>
                      </button>
                      <button
                        v-if="isAllowToUpdate"
                        class="btn btn-default"
                        type="button"
                        @click="updateItem(item)"
                      >
                        <span>Edit</span>
                      </button>
                      <button
                        v-if="isAllowToDelete"
                        class="btn btn-default"
                        type="button"
                        @click="confirmDelete(item)"
                      >
                        <i class="ic-close"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="settingmodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Setting</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="form-group">
                      <label class="required">Key</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{
                          readonly: isUpdate,
                          'field-error': isSubmitted && $v.model.key.$error,
                        }"
                        v-model="model.key"
                        :disabled="isViewOnly"
                      />
                      <div v-if="isSubmitted && $v.model.key.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.key.required"
                          >Key is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.key.maxLength"
                          >Key must be less than
                          {{ $v.model.key.$params.maxLength.max }}
                          characters</small
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        class="required"
                        v-if="isDriverJobOpenLimit || isMarkAsCompleteBuffer"
                      >
                        Value
                        <span>{{
                          isDriverJobOpenLimit ? "(Months)" : "(Hours)"
                        }}</span>
                      </label>
                      <label class="required" v-else>{{
                        model.key === "BookingLimit" ? "No. of Months" : "Value"
                      }}</label>
                      <input
                        v-if="!model.isConfidential"
                        type="text"
                        class="form-control"
                        :class="{
                          'field-error': isSubmitted && $v.model.value.$error,
                        }"
                        v-model="model.value"
                        :disabled="isViewOnly"
                      />
                      <input
                        v-else
                        type="password"
                        class="form-control"
                        :class="{
                          'field-error': isSubmitted && $v.model.value.$error,
                        }"
                        name="value"
                        v-model="model.value"
                        :disabled="isViewOnly"
                        required
                      />
                      <div v-if="isSubmitted && $v.model.value.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.value.required"
                          >Value is required</small
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Description</label>
                      <textarea
                        class="form-control"
                        :class="{
                          'field-error':
                            isSubmitted && $v.model.description.$error,
                        }"
                        rows="4"
                        v-model="model.description"
                        :disabled="isViewOnly"
                      ></textarea>
                      <div
                        class="text-right word-count"
                        v-if="model.description"
                      >
                        {{ model.description.length }} &#47;
                        {{ $v.model.description.$params.maxLength.max }}
                        characters
                      </div>
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.description.maxLength"
                        >Description must be less than
                        {{ $v.model.description.$params.maxLength.max }}
                        characters</small
                      >
                    </div>
                    <div class="form-group">
                      <label class="cursor-pointer w-max-content">
                        <input
                          type="checkbox"
                          class="control-checkbox"
                          v-model="model.isConfidential"
                        />
                        <span class="pl-5 font-weight-normal v-align-middle">
                          Confidential
                        </span>
                      </label>
                      <!-- <div class="btn-group-checkbox">
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="model.isConfidential" />
                            {{
                              model.isConfidential ? "Confidential" : "Non Confidential"
                            }}
                          </label>
                        </div>
                      </div> -->
                    </div>
                    <div class="modal-footer" v-if="!isViewOnly">
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import settingService from "@/services/master/setting/settingService.js";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isDriverJobOpenLimit: function () {
      return (
        this.model && this.model.key.toLowerCase() === "driver job open limit"
      );
    },
    isMarkAsCompleteBuffer: function () {
      return (
        this.model && this.model.key.toLowerCase() === "markascompletebuffer"
      );
    },
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      isSubmitted: false,
      allPermissions: [],
      isViewOnly: false,
      isUpdate: false,
      itemToBeDeleted: null,
      items: [],
      model: {
        key: "",
        value: "",
        description: null,
      },
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        key: { required, maxLength: maxLength(100) },
        value: { required },
        description: { maxLength: maxLength(500) },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
    }
  },
  mounted() {
    $(this.$refs.settingmodal).on("hidden.bs.modal", this.closeSettingModal);
  },
  updated() {
    this.$helper.collapseMenu("administration");
    this.$helper.setNavigationClass("setting-link");
  },
  beforeDestroy() {
    location.reload();
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    resetModel() {
      this.model = {
        key: "",
        value: "",
        description: null,
      };
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openSettingModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.settingmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeSettingModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.settingmodal).modal("hide");
    },
    createItem() {
      this.isViewOnly = false;
      this.isUpdate = false;
      this.resetModel();
      this.openSettingModal({
        key: "",
        value: "",
        description: null,
        isConfidential: false,
      });
    },
    updateItem(item) {
      if (item.key.toLowerCase() === "terms & conditions") {
        this.$router.push("/administration/setting/term-conditions-form");
      } else {
        this.isViewOnly = false;
        this.isUpdate = true;
        this.openSettingModal(item);
      }
    },
    viewItem(item) {
      this.isViewOnly = true;
      this.isUpdate = false;
      this.openSettingModal(item);
    },
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        const response = await settingService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        if (this.isUpdate) {
          await settingService.update(this.model);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          await settingService.create(this.model);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        await this.$store.dispatch("setting/removeSetting");
        await this.getAll();
        this.closeSettingModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        await settingService.update(item);
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
        await this.$store.dispatch("setting/removeSetting");
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await settingService.delete(this.itemToBeDeleted.key);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.$store.dispatch("setting/removeSetting");
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/setting/Setting.vue